import React, { useCallback, useMemo } from "react";
import TextMessage from "../addbots/TextMessage";
import MediaMessage from "../addbots/MediaMessage";
import InteractiveButtonsBuilder from "../addbots/InteractiveButtonsBuilder";
import SendLocation from "../addbots/SendLocation";
import MessageComposer from "../addbots/InteractiveList";
import SendLocationRequest from "../addbots/SendLocationRequest";
import InteractiveCtaUrls from "../addbots/InteractiveCtaUrls";
import EndpointMessage from "../addbots/EndpointMessage";
import { MEDIA_TYPES } from "../../../utils/constants";
import { Box } from "@mui/material";
import { useReactFlow } from "reactflow";
import { toast } from "react-toastify";
import { da } from "date-fns/locale";
import AddForm from "../addbots/AddForm";
import AddTemplate from "../addbots/AddTemplate";

export const TypeComponentMap = {
  text: TextMessage,
  image: MediaMessage,
  document: MediaMessage,
  video: MediaMessage,
  reply_buttons: InteractiveButtonsBuilder,
  location: SendLocation,
  list: MessageComposer,
  location_request_message: SendLocationRequest,
  interactive_cta_urls: InteractiveCtaUrls,
  endpoint: EndpointMessage,
  chatform: AddForm,
  template: AddTemplate,
};
const MessageViewerEdit = ({ id, data, handleClose }) => {
  const { setNodes } = useReactFlow();
  const updateNode = useCallback((nodeData) => {
    setNodes((nds) =>
      nds.map((item) =>
        item.id === id
          ? { ...item, data: { ...item.data, ...nodeData } }
          : { ...item }
      )
    );
    handleClose?.();
    toast.success("Saved locally!");
  }, []);

  const MemoizedComponent = useMemo(() => {
    const MyComp = TypeComponentMap[data.category];
    if (MEDIA_TYPES.includes(data.category.toUpperCase())) {
      return (
        <MyComp
          type={data.category}
          preview={true}
          value={data}
          onUpdate={(newV) => {
            updateNode(newV);
          }}
        />
      );
    } else {
      return (
        <MyComp
          preview={true}
          value={data}
          onUpdate={(newV) => {
            updateNode(newV);
          }}
        />
      );
    }
  }, [data]);
  return <Box>{MemoizedComponent}</Box>;
};

export default MessageViewerEdit;
